import { createSlice } from '@reduxjs/toolkit';

import { fetchLeaderboard } from './leaderboard.thunk';
import type { LeaderboardItem } from '../api/leaderboard.types';

interface LeaderboardState {
  items: LeaderboardItem[];
  period: string;
  loading: boolean;
  error: string | null;
}

const initialState: LeaderboardState = {
  items: [],
  period: '',
  loading: false,
  error: null,
};

export const leaderboardSlice = createSlice({
  name: 'leaderboard',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchLeaderboard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchLeaderboard.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.items;
        state.period = action.payload.period;
      })
      .addCase(fetchLeaderboard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default leaderboardSlice.reducer;
